import SHA256 from "crypto-js/sha256";
export const setCookie = (msisdn: any, subPackage: any, token: any) => {
  clearAllCookies();
  let data = {
    msisdn: msisdn,
    subPackage: subPackage,
    token: token,
  };
  const maxAge = 30 * 24 * 60 * 60;
  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data)
  )}; SameSite=Strict; path=/; max-age=${maxAge}`;
};

export const getCookie = (name: any) => {
  try {
    const cookies = document.cookie
      .split(";")
      .reduce((acc: Record<string, string>, cookie) => {
        const [key, value] = cookie.split("=");
        acc[key.trim()] = decodeURIComponent(value);
        return acc;
      }, {});
    console.log("cookies[name]", JSON.parse(cookies[name]));
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};
export const clearAllCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const clearUserSession = () => {
  clearAllCookies();
  localStorage.removeItem("packageChangeTime");
};


export const sha256Hash = (value: string) => {
  return SHA256(value.trim().toLowerCase()).toString();
};